<template>
  <section class="wf-ideabook-previous-issues py-5">
    <div class="container-fluid">
      <h3>{{ ideabookdetail.parent.ideabookFolderDownloadsTitle }}</h3>

      <p v-html="ideabookdetail.parent.ideabookFolderDownloadsDescription"></p>
      <div class="wf-ideabook-downloads">
        <div class="form-row flex-column flex-sm-row mb-4">
          <div class="col-auto">
            <label class="input-label" for="ideabook-downloads-select">
              Publication:
            </label>
          </div>
          <div class="col">
            <select
              class="custom-select"
              id="ideabook-downloads-select"
              v-model="selectedIdeabookIndex"
            >
              <option
                v-for="(ideabook, index) in ideabooks"
                :value="index"
                :key="index"
              >
                {{ ideabook.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="wf-ideabook-downloads-box">
          <div class="description font-weight-bold text-uppercase mb-4">
            Ideabook / {{ ideabooks[selectedIdeabookIndex].name }}:
          </div>
          <a
            class="btn btn-white border border-dark justify-content-start"
            :href="ideabooks[selectedIdeabookIndex].url"
            target="_blank"
          >
            <span class="png-icon png-icon-icons-glyph--k-btn-download"></span>
            <span class="ml-2"> Download PDF </span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    ideabooks: {
      type: Array,
      required: true
    },
    ideabookdetail: {
      required: true
    }
  },
  data() {
    return {
      selectedIdeabookIndex: 0
    };
  }
};
</script>
